import axios from "axios";
import history from "./history";
import { snackbar } from "./snackbarActions";
import { bun_server } from "./baseUrl";
import dict from "../../Data/dict.json";

export const set_value_ai_preset = (body) => {
  return {
    type: "set_value_ai_preset",
    payload: body,
  };
};

export const push_value_layer_ai = (body) => {
  return {
    type: "push_value_layer_ai",
    payload: body,
  };
};

/**
 * @function_name : push_layer_id_ai
 * @endpoint : /sini_v2/push_layer_id_ai
 * @methode : put
 * @params :
 * @body : layer_id, layer_name
 * @success_response : layer_id, layer_name
 */
export const push_layer_id_ai = (body) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "push_layer_id_ai",
    });

    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.post(
      bun_server + `/sini_v2/calculate_data`,
      body,
      config
    );
    const size = res.data.size; // total data
    const limit = 10; // batch size
    const selectedFields = res.data.selectedFields;

    const generate_batch = (total_count, limit) => {
      const batches = [];
      let skip = 0;
      while (skip < total_count) {
        batches.push({ skip: skip, limit: limit });
        skip += limit;
      }
      return batches;
    };
    console.log(size);

    if (size > 10_000) {
      dispatch(
        snackbar({
          is_open: true,
          status: "error",
          message:
            dict["Data was too big"][localStorage.getItem("lang") || "eng"],
        })
      );
    } else if (size === 0) {
      dispatch(
        snackbar({
          is_open: true,
          status: "error",
          message:
            dict["Data was empty"][localStorage.getItem("lang") || "eng"],
        })
      );
    } else {
      const batch_array = generate_batch(size, limit);

      const delay_ms = 500; // delay antar batch untuk safety

      /** Delay helper */
      const delay_promise = () =>
        new Promise((resolve) => setTimeout(resolve, delay_ms));

      /** Process semua batch secara sequential */
      const process_items = () => {
        return batch_array.reduce(
          (prev_promise, item, index) =>
            prev_promise.then((results) =>
              process_item(item, index).then((result) => [...results, result])
            ),
          Promise.resolve([]) // awal array kosong
        );
      };

      /** Logic untuk 1 batch */
      const process_item = async (item, index) => {
        await delay_promise();
        const { skip, limit } = item;

        const progress = Math.round(((index + 1) / batch_array.length) * 100);
        console.log(skip, limit);
        try {
          const batchRes = await axios.put(
            bun_server + `/sini_v2/push_layer_id_ai_batch`,
            { layer_id: body.layer_id, skip, limit, selectedFields },
            config
          );

          dispatch({
            type: "set_value_ai_preset",
            payload: {
              key: "current_progress_demo",
              value: progress,
            },
          });
          return batchRes.data; // simpan hasil
        } catch (error) {
          return null;
        }
      };

      /** Jalankan semua batch */
      await process_items();

      /** Kirim semua hasil batch ke merge endpoint */
      try {
        await axios.post(
          bun_server + `/sini_v2/merge_layer_resume`,
          {
            layer_id: body.layer_id,
          }, // filter null
          config
        );
        const body_gen_calc = {
          layer_id: body.layer_id,
        };
        const res_recomendation = await axios.post(
          bun_server + `/sini_v2/gen_recomendations`,
          body_gen_calc,
          config
        );

        const gen_recomendation = {
          role: "assistant",
          content: ` ${res_recomendation?.data?.gen_recomendations || {}}`,
          layer_action_list: [],
          result_list: [],
        };

        dispatch({
          type: "push_value_sini_data",
          payload: {
            key: "chat_list",
            value: gen_recomendation,
          },
        });
      } catch (error) {
        dispatch(
          snackbar({
            is_open: true,
            status: "error",
            message: error.message,
          })
        );
      }
    }

    dispatch({
      type: "clear_loading_action",
      payload: "push_layer_id_ai",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "push_layer_id_ai",
    });
  }
};

/**
 * @function_name : pull_layer_id_ai
 * @endpoint : /sini_v2/ai_preset/pull_layer_id_ai
 * @methode : put
 * @params :
 * @body : layer_id, layer_name
 */
export const pull_layer_id_ai = (body) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "pull_layer_id_ai",
    });

    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.put(
      bun_server + `/sini_v2/ai_preset/pull_layer_id_ai`,
      body,
      config
    );
    const data = res?.data;
    const layer_id = data?.layer_id;
    if (layer_id) {
      dispatch({
        type: "pull_value_layer_ai_string",
        payload: {
          key: "layer_id_ai",
          value: layer_id,
        },
      });
    }

    dispatch({
      type: "clear_loading_action",
      payload: "pull_layer_id_ai",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "pull_layer_id_ai",
    });
  }
};

/**
 * @function_name : get_layer_id_ai
 * @endpoint : /sini_v2/ai_preset/get_layer_id_ai
 * @methode : get
 * @params :
 * @body :
 */
export const get_layer_id_ai = () => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "get_layer_id_ai",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.get(
      bun_server + `/sini_v2/ai_preset/get_layer_id_ai`,
      config
    );
    const data = res?.data;
    dispatch({
      type: "set_value_ai_preset",
      payload: {
        key: "layer_id_ai",
        value: data,
      },
    });

    dispatch({
      type: "clear_loading_action",
      payload: "get_layer_id_ai",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "get_layer_id_ai",
    });
  }
};

/**
 * @function_name : get_request_resume_status
 * @endpoint : /sini_v2/get_request_resume_status
 * @methode : get
 * @params :
 * @body :
 */
export const get_request_resume_status = (layer_id) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "get_request_resume_status",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.get(
      bun_server + `/sini_v2/get_request_resume_status/${layer_id}`,
      config
    );

    const data = res?.data?.requests?.status;
    dispatch({
      type: "set_value_ai_preset",
      payload: {
        key: "request_resume_status",
        value: data,
      },
    });

    dispatch({
      type: "clear_loading_action",
      payload: "get_request_resume_status",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "get_request_resume_status",
    });
  }
};

/**
 * @function_name : get_recomendation
 * @endpoint : /sini_v2/get_recomendation
 * @methode : get
 * @params :
 * @body :
 */
export const get_recomendation = (layer_id) => async (dispatch) => {
  try {
    console.log(layer_id);
    dispatch({
      type: "set_loading_action",
      payload: "get_recomendation",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.get(
      bun_server + `/sini_v2/get_recomendation/${layer_id}`,
      config
    );
    console.log(res?.data.gen_recomendations);
    if (res?.data?.gen_recomendations) {
      const gen_recomendation = {
        role: "assistant",
        content: ` ${res?.data?.gen_recomendations || {}}`,
        layer_action_list: [],
        result_list: [],
      };

      dispatch({
        type: "push_value_sini_data",
        payload: {
          key: "chat_list",
          value: gen_recomendation,
        },
      });
    }

    dispatch({
      type: "clear_loading_action",
      payload: "get_recomendation",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "get_recomendation",
    });
  }
};

/**
 * @function_name : get_all_data_ai_object
 * @endpoint : /sini_v2/ai_preset/get_all_data_ai_object
 * @methode : get
 * @params :
 * @body :
 */
export const get_all_data_ai_object = (params) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "get_all_data_ai_object",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    const { request_id } = params;

    const res = await axios.get(
      bun_server +
        `/sini_v2/ai_preset/get_all_data_ai_object?request_id=${request_id}`,
      config
    );
    const data = res?.data || {};
    const { active_layer_list, all_data_ai_object } = data;

    const { chat_list, layer_query_list } = all_data_ai_object;

    dispatch({
      type: "set_value_ai_preset",
      payload: {
        key: "active_layer_list",
        value: active_layer_list,
      },
    });
    dispatch({
      type: "set_value_ai_preset",
      payload: {
        key: "request_id",
        value: request_id,
      },
    });
    dispatch({
      type: "set_value_ai_preset",
      payload: {
        key: "chat_list",
        value: chat_list,
      },
    });
    dispatch({
      type: "set_value_ai_preset",
      payload: {
        key: "layer_query_list",
        value: layer_query_list,
      },
    });

    const delay_milisecond_constant = 0;
    const delay_promise = () =>
      new Promise((res) => setTimeout(res, delay_milisecond_constant));
    const parent_function = () => {
      return layer_query_list.reduce(
        (last_promise, object) =>
          last_promise.then((result_sum) =>
            child_function(object).then((result_current) => [
              ...result_sum,
              result_current,
            ])
          ),
        Promise.resolve([])
      );
    };
    const child_function = async (item) => {
      return delay_promise().then(() => {
        const core_function = async () => {
          try {
            const layer_id = item?.layer_id?._id;
            const query_list = item?.query_list;
            console.log("query_list=", query_list);
            const body = { request_id, layer_id, query_list };
            const res = await axios.post(
              bun_server + `/sini_v2/ai_preset/get_features_by_query_list`,
              body,
              config
            );
            const data = res.data;
            const { features, fields } = data;

            dispatch({
              type: "set_value_inside_array",
              payload: {
                layer_id,
                key_list: "layer_query_list",
                key: "fields",
                value: fields,
              },
            });
            dispatch({
              type: "set_value_inside_array",
              payload: {
                layer_id,
                key_list: "layer_query_list",
                key: "features",
                value: features,
              },
            });
            dispatch({ type: "ai_preset_update_layer" });
            dispatch({ type: "ai_preset_update_fly" });
          } catch (error) {}
        };
        return core_function();
      });
    };
    await parent_function().then();

    dispatch({
      type: "clear_loading_action",
      payload: "get_all_data_ai_object",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "get_all_data_ai_object",
    });
  }
};

/**
 * @function_name : gen_layer
 * @endpoint : /sini_v2/ai_preset/gen_layer
 * @methode : post
 * @params :
 * @body : prompt_text
 */
export const gen_layer = (body) => async (dispatch) => {
  try {
    console.log("gen_layer");
    const chat_object = {
      role: "user",
      content: body?.prompt_text,
    };
    dispatch({
      type: "push_value_layer_ai",
      payload: {
        key: "chat_list",
        value: chat_object,
      },
    });

    dispatch({
      type: "set_value_ai_preset",
      payload: {
        key: "current_step",
        value: "step_1",
      },
    });

    dispatch({
      type: "set_loading_action",
      payload: "gen_layer",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.post(
      bun_server + `/sini_v2/ai_preset/gen_layer`,
      body,
      config
    );
    const data = res?.data || [];
    dispatch({
      type: "set_value_ai_preset",
      payload: {
        key: "active_layer_list",
        value: data,
      },
    });
    dispatch({ type: "ai_preset_update_step" });

    dispatch({
      type: "clear_loading_action",
      payload: "gen_layer",
    });
    return data;
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "gen_layer",
    });
  }
};

/**
 * @function_name : gen_query
 * @endpoint : /sini_v2/ai_preset/gen_query
 * @methode : post
 * @params :
 * @body : prompt_text, layer_list_input
 */
export const gen_query = (body) => async (dispatch) => {
  try {
    console.log("gen_query");
    dispatch({
      type: "set_value_ai_preset",
      payload: {
        key: "current_step",
        value: "step_2",
      },
    });

    dispatch({
      type: "set_loading_action",
      payload: "gen_query",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.post(
      bun_server + `/sini_v2/ai_preset/gen_query`,
      body,
      config
    );
    const data = res?.data;
    const request_id = data?.request_id;
    const currentSearchParams = new URLSearchParams(window.location.search);
    currentSearchParams.set("request_id", request_id); // add or update the request_id
    history.push({
      pathname: "/sini",
      search: currentSearchParams.toString(),
    });

    const { layer_query_list } = data;
    dispatch({
      type: "set_value_ai_preset",
      payload: {
        key: "layer_query_list",
        value: layer_query_list,
      },
    });
    dispatch({ type: "ai_preset_update_step" });

    dispatch({
      type: "clear_loading_action",
      payload: "gen_query",
    });
    return layer_query_list;
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "gen_query",
    });
  }
};

/**
 * @function_name : looping_query_list
 * @endpoint : /sini_v2/ai_preset/looping_query_list
 * @methode : get
 * @params :
 * @body :
 */
export const looping_query_list = (body) => async (dispatch) => {
  try {
    console.log("looping_query_list");
    dispatch({
      type: "set_value_ai_preset",
      payload: {
        key: "current_step",
        value: "step_3",
      },
    });

    dispatch({
      type: "set_loading_action",
      payload: "looping_query_list",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const { layer_query_list, request_id } = body;

    const delay_milisecond_constant = 0;
    const delay_promise = () =>
      new Promise((res) => setTimeout(res, delay_milisecond_constant));
    const parent_function = () => {
      return layer_query_list.reduce(
        (last_promise, object) =>
          last_promise.then((result_sum) =>
            child_function(object).then((result_current) => [
              ...result_sum,
              result_current,
            ])
          ),
        Promise.resolve([])
      );
    };
    const child_function = async (item) => {
      return delay_promise().then(() => {
        const core_function = async () => {
          try {
            const layer_id = item?.layer_id?._id;
            const query_list = item?.query_list;
            console.log("query_list=", query_list);
            const body = { request_id, layer_id, query_list };
            const res = await axios.post(
              bun_server + `/sini_v2/ai_preset/get_features_by_query_list`,
              body,
              config
            );
            const data = res.data;
            const { features, fields } = data;

            dispatch({
              type: "set_value_inside_array",
              payload: {
                layer_id,
                key_list: "layer_query_list",
                key: "fields",
                value: fields,
              },
            });
            dispatch({
              type: "set_value_inside_array",
              payload: {
                layer_id,
                key_list: "layer_query_list",
                key: "features",
                value: features,
              },
            });
            dispatch({ type: "ai_preset_update_layer" });
            dispatch({ type: "ai_preset_update_fly" });
          } catch (error) {}
        };
        return core_function();
      });
    };
    await parent_function().then(() => {
      dispatch({ type: "ai_preset_update_step" });

      dispatch({
        type: "clear_loading_action",
        payload: "looping_query_list",
      });
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "looping_query_list",
    });
  }
};

/**
 * @function_name : gen_color
 * @endpoint : /sini_v2/ai_preset/gen_color
 * @methode : post
 * @params :
 * @body :
 */
export const gen_color = (body) => async (dispatch) => {
  try {
    console.log("gen_color");
    dispatch({
      type: "set_value_ai_preset",
      payload: {
        key: "current_step",
        value: "step_4",
      },
    });

    dispatch({
      type: "set_loading_action",
      payload: "gen_color",
    });

    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.post(
      bun_server + `/sini_v2/ai_preset/gen_color`,
      body,
      config
    );

    const data = res?.data || {};
    const output_list = data?.output_list || [];
    output_list.forEach((item) => {
      const { layer_id, style_object } = item;
      console.log("style_object=", style_object);
      dispatch({
        type: "set_value_inside_array",
        payload: {
          layer_id,
          key_list: "layer_query_list",
          key: "style_object",
          value: style_object,
        },
      });
    });

    dispatch({ type: "ai_preset_update_layer" });
    dispatch({ type: "ai_preset_update_step" });

    // await dispatch(gen_message(body));

    dispatch({
      type: "clear_loading_action",
      payload: "gen_color",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "gen_color",
    });
  }
};

/**
 * @function_name : gen_message
 * @endpoint : /sini_v2/ai_preset/gen_message
 * @methode : post
 * @params :
 * @body :
 */
export const gen_message = (body) => async (dispatch) => {
  try {
    console.log("gen_message");
    dispatch({
      type: "set_loading_action",
      payload: "gen_message",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.post(
      bun_server + `/sini_v2/ai_preset/gen_message`,
      body,
      config
    );
    const data = res.data;

    dispatch({
      type: "push_value_layer_ai",
      payload: {
        key: "chat_list",
        value: data,
      },
    });

    dispatch({
      type: "clear_loading_action",
      payload: "gen_message",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "gen_message",
    });
  }
};
